// DS: i1.7
import React from 'react';
import IconWrap from '../../IconWrap';
const Fragments = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.5 9.5l2.35 4.15L15 16l-4.15 2.35L8.5 22.5l-2.35-4.15L2 16l4.15-2.35L8.5 9.5zm9.5 0l1.447 2.553L22 13.5l-2.553 1.447L18 17.5l-1.447-2.553L14 13.5l2.553-1.447L18 9.5zm-5.5-7l1.627 2.873L17 7l-2.873 1.627L12.5 11.5l-1.627-2.873L8 7l2.873-1.627L12.5 2.5z",
        clipRule: "evenodd"
    })));
};
Fragments.displayName = 'Fragments';
export default Fragments;
